import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { v4 } from 'uuid';
import { appConfig } from '../config/AppConfig';
import { accountController, axiosClient, userController } from '../controllers';
import { LocalStore } from '../helpers/localStorage';
import { Account } from '../models/Account';
import { ChangePassword, Login } from '../models/Login';

const JWT_KEY = 'jwt';

interface State {
    jwt?: string | null;
    isAuth?: boolean;
    account?: Account;
    userAvatar?: string;
    isLoading: boolean;
}

export default function UseAuth() {
    const navigate = useNavigate();
    const location = useLocation();
    const [state, setState] = useState<State>({ jwt: LocalStore.getValue(JWT_KEY), isAuth: false, isLoading: true });

    useEffect(() => {
        const jwt = LocalStore.getValue(JWT_KEY);
        if (jwt) {
            if (location.pathname.includes('change-password')) {
                logout();
            } else {
                loginWithJwt(jwt as string);
            }
        } else {
            logout();
        }
    }, []);

    const loginWithEmail = async (login: Login) => {
        await accountController.login(login).then((jwt) => {
            loginWithJwt(jwt);
        });
        // .catch((res) => {
        //     return res.status;
        // });UseAuth
    };

    const loginWithJwt = async (jwt: string) => {
        axiosClient.defaults.headers['authorization'] = 'Bearer ' + jwt;
        setState({ isAuth: false, jwt, isLoading: true });
        await userController
            .getMe()
            .then((account) => {
                setState({ isAuth: true, jwt, isLoading: true });
                LocalStore.setValue(JWT_KEY, jwt);
                setState((prev) => ({
                    ...prev,
                    isAuth: true,
                    isLoading: false,
                    account,
                    userAvatar: getAvatar(Number(account.accountId)),
                }));
                if (location.pathname === '/' || location.pathname === '/login') {
                    navigate('/', { replace: true });
                } else {
                    navigate(location.pathname, { replace: true });
                }
            })
            .catch((res) => {
                logout();
            });
    };

    const sendTokenToEmail = async (email: string) => {
        await accountController.sendLinkToMail(email).then((res) => {});
    };

    const changePassword = async (change: ChangePassword) => {
        await accountController.changePass(change).then((res) => {});
    };

    const changePassAccount = async (change: ChangePassword) => {
        await accountController.changePassAccount(change).then((res) => {
            if (state.account) {
                setState({ ...state, account: { ...state.account, password: change.password } });
            }
        });
    };

    const updateAccount = async (updateAccount: Account) => {
        await accountController.updateAccount(updateAccount).then((res) => {
            setState((prev) => ({ ...prev, account: res }));
        });
    };

    const logout = () => {
        LocalStore.deleteKey(JWT_KEY);
        setState({ isAuth: false, jwt: null, account: {} as any, isLoading: false });
        // if (!location.pathname.includes('change-password')) {
        //     navigate('/', { replace: true });
        // }
    };

    const getAvatar = (idAccount: number) => {
        const uuid = v4();
        const avatar = `${appConfig.gateway.apiAzureMedia}/${idAccount}?id=${uuid}`;
        return avatar;
    };

    const isSilverRole = () => {
        return state.account?.label == 'Client' || state.account?.label == 'employee';
    };
    const isGoldRole = () => {
        return state.account?.label == 'Account manager' || state.account?.label == 'Managing agent';
    };
    const isBronzeRole = () => {
        return state.account?.label == 'Tenant';
    };

    return {
        ...state,
        loginWithEmail,
        loginWithJwt,
        sendTokenToEmail,
        logout,
        changePassword,
        updateAccount,
        changePassAccount,
        setState,
        getAvatar,
        isSilverRole,
        isGoldRole,
        isBronzeRole,
    };
}

export const AuthContext = React.createContext<ReturnType<typeof UseAuth>>({} as any);
